export enum TypeBanner {
    referente_richiesta = 'CAMBIO_REFERENTE_RICHIESTA_BANNER',
    referente_proposta = 'CAMBIO_REFERENTE_PROPOSTA_BANNER',
    modulo = 'COMPLETA_MODULO',
    competenze = 'REMINDER_COMPETENZE_BANNER',
    associazione_classe_banner = 'RICHIESTA_ASSOCIAZIONE_CLASSE_BANNER'
}
